/**
 * @generated SignedSource<<0165fc45b26822a5a3a9ac9ebf8d14f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyOpenOpportunityListV2Pagination_organization$data = {
  readonly id: string;
  readonly jobs: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly jobPosting: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"JobPostingCard_jobPosting">;
        } | null;
      };
    }>;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
  };
  readonly " $fragmentType": "CompanyOpenOpportunityListV2Pagination_organization";
};
export type CompanyOpenOpportunityListV2Pagination_organization$key = {
  readonly " $data"?: CompanyOpenOpportunityListV2Pagination_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyOpenOpportunityListV2Pagination_organization">;
};

import CompanyOpenOpportunityListV2Query_graphql from './CompanyOpenOpportunityListV2Query.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jobs"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CompanyOpenOpportunityListV2Query_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CompanyOpenOpportunityListV2Pagination_organization",
  "selections": [
    {
      "alias": "jobs",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "statuses": [
              "POSTED"
            ]
          }
        }
      ],
      "concreteType": "OrganizationJobConnection",
      "kind": "LinkedField",
      "name": "__CompanyOpenOpportunityListV2_jobs_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationJobEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Job",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobPosting",
                  "kind": "LinkedField",
                  "name": "jobPosting",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobPostingCard_jobPosting"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__CompanyOpenOpportunityListV2_jobs_connection(filter:{\"statuses\":[\"POSTED\"]})"
    },
    (v1/*: any*/)
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "b08c30418c909f4f5c434096103971b6";

export default node;
